import downloadDocument from './downloadDocument';
import downloadDocumentAdditionalInformation from './downloadDocumentAdditionalInformation';

export const DocumentService = {
  downloadDocument,
  downloadDocumentAdditionalInformation,
};
